/* eslint-disable unicorn/filename-case */
import { featureFlags } from './featureFlags';

const getValueFeatureFlagFromURL = (feature: string): boolean | null => {
	const url = new URL(window.location.href);
	const value = url.searchParams.get(feature);
	if (value === 'true' || value === 'false') return value === 'true';

	return null;
};

const featureFlagValidate = (feature: string, value: boolean): boolean => {
	if(import.meta.env.REACT_APP_ENV === 'prod') return value;

	const featureFlagFromURL = getValueFeatureFlagFromURL(feature);

	return featureFlagFromURL ?? value;
};

function toRecord(obj: Record<string, unknown>): Record<string, boolean> {
	return Object.fromEntries(
		Object.entries(obj).map(([key, value]) => [
			key,
			featureFlagValidate(key, value as boolean),
		]),
	);
}

export const getFeaturesFlags = (): Record<string, boolean> => {
	return toRecord(featureFlags);
};

export const getFeatureFlag = (feature: string): boolean => {
	const featureValue = featureFlags[feature];

	return featureFlagValidate(feature, featureValue);
};
